import { GetUserOrganizationsDocument } from "@/core/api/graphql/types";
import { graphqlClient } from "../../../client";
import type {
  GetOrganizationsQueryVariables,
  OrganizationFieldsFragment,
  HerasOrganizationType,
} from "@/core/api/graphql/types";

interface IOrganizationsType {
  items: OrganizationFieldsFragment[];
  totalCount: number;
  pageInfo: {
    hasNextPage: boolean;
    endCursor?: string;
  };
}

export async function getOrganizations(payload: GetOrganizationsQueryVariables): Promise<IOrganizationsType> {
  const { data } = await graphqlClient.query({
    query: GetUserOrganizationsDocument,
    variables: payload,
  });

  const organizations = data.me?.contact?.organizations;

  return {
    items: (organizations?.items as HerasOrganizationType[]) ?? [],
    totalCount: organizations?.totalCount ?? 0,
    pageInfo: {
      hasNextPage: organizations?.pageInfo?.hasNextPage ?? false,
      endCursor: organizations?.pageInfo?.endCursor,
    },
  };
}
